import React from "react";

/* React Admin */
import {
  TextInput,
  NumberInput,
  BooleanInput,
  FormDataConsumer,
  SelectInput,
  required,
  regex,
  useAuthenticated,
  useRedirect,
  email,
} from "react-admin";

/* Material UI Components */
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";

/* Material UI Styles*/
import {
  ThemeProvider,
  withStyles,
  createMuiTheme,
  makeStyles,
} from "@material-ui/core/styles";

/* React final Form */
import { Form } from "react-final-form";

/* Parse */
import Parse from "parse";

/* Hooks */
import { FetchIndustries } from "./hooks";
import { useRouteState } from "../../Utils/hooks";

/* Custom Components */
import AvatarInput3 from "../../Components/AvatarInput";

/* Image Assets */
import professionals from "./../../images/signupV2-professionals.svg";

import { Link } from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
const SignupV2Button = withStyles({
  root: {
    backgroundColor: "#EF8354",
    color: "#fff",
  },
})(Button);

const useStyle = makeStyles({
  leftPanel: {
    height: "100vh",
    backgroundColor: "#EF8354",
  },
  rightPanel: {
    height: "100vh",
  },
  bannerImage: {
    margin: "8%",
    marginTop: "12%",
    width: "40vw",
  },
  bannerHeader: {
    color: "#4F5D75",
    fontWeight: "bold",
  },
  formPaper: {
    width: "25vw",
    height: "75vh",
    margin: "auto",
    marginTop: "5vh",
    padding: "20px",
    borderRadius: "20px",
  },
  formPaperSm: {
    width: "85vw",
    height: "85vh",
    margin: "auto",
    marginTop: "2vh",
    padding: ".3rem",
    borderRadius: "20px",
  },

  verticalN10: {
    margin: "auto",
    marginTop: "-10px",
  },
  vertical0: {
    margin: "auto",
  },
  vertical10: {
    margin: "auto",
    marginTop: "10px",
  },
  verticalCheckBox: {
    margin: "auto",
    marginTop: "5px",
  },
  vertical20: {
    margin: "auto",
    marginTop: "20px",
  },
  vertical30: {
    margin: "auto",
    paddingTop: "30px",
  },
  avatar: {
    width: "180px",
    height: "180px",
  },
  avatarSm: {
    width: "120px",
    height: "120px",
  },
  field: {
    width: "20vw",
  },
  fieldSm: {
    width: "60vw",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const UserInfoFrom = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest
}) => {
  const industryCategories = FetchIndustries();
  const indusChoices = industryCategories.loaded
    ? industryCategories.data.map((ctgry) => {
        return { id: ctgry.id, name: ctgry.Category };
      })
    : [{ id: "1", name: "Loading Categories ...." }];

  const classes = useStyle();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));

  const location = useRouteState();
  const linkedIn = location.pathname.includes("/user-info/linkedin");
  const [state, setState] = React.useState({
    checkedTerm: false,
  });
  const [termsDialog, setTermsDialog] = React.useState(false);

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleClose = () => {
    setTermsDialog(false);
  };

  const validateName = regex(/^[a-zA-Z ]{2,100}$/);
  const validatePhone = (value) =>
    value.toString().length === 10
      ? undefined
      : { message: "Invalid Mobile Number" };

  const ConditionLink = (
    <Link
      style={{
        textDecoration: "none",
      }}
      onClick={() => {
        setTermsDialog(true);
      }}
    >
      Agree to terms and conditions
    </Link>
  );

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid container direction="column">
          <Grid item className={classes.vertical10}>
            <AvatarInput3 size="100px" source="profileImage" />
          </Grid>
          <Grid item className={classes.verticalN10}>
            <TextInput
              source="name"
              label="Name"
              variant="outlined"
              className={isDesktop ? classes.field : classes.fieldSm}
              validate={[required(), validateName]}
            />
          </Grid>
          {linkedIn ? (
            <Grid item className={classes.verticalN10}>
              <TextInput
                source="email"
                label="Email"
                variant="outlined"
                className={isDesktop ? classes.field : classes.fieldSm}
                validate={[required(), email()]}
              />
            </Grid>
          ) : null}
          <Grid item className={classes.verticalN10}>
            <NumberInput
              source="mobileNo"
              label="Mobile Number"
              variant="outlined"
              className={isDesktop ? classes.field : classes.fieldSm}
              validate={[required(), validatePhone]}
            />
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item className={classes.verticalN10}>
                <BooleanInput source="isMentor" label="Become a Mentor!" />
              </Grid>
              <FormDataConsumer subscription={{ values: true }}>
                {(formData, ...rest) => {
                  return !formData.formData.isMentor ? null : (
                    <Grid item className={classes.vertical0}>
                      <SelectInput
                        source="industry"
                        label="Industry"
                        variant="outlined"
                        className={isDesktop ? classes.field : classes.fieldSm}
                        validate={required()}
                        optionValue="name"
                        choices={indusChoices}
                      />
                    </Grid>
                  );
                }}
              </FormDataConsumer>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item className={classes.verticalN10}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={state.checkedTerm}
                      onChange={handleChange}
                      name="checkedTerm"
                      color="primary"
                      required
                    />
                  }
                  label={ConditionLink}
                />
                {/* <Link
                  onClick={() => {
                    setTermsDialog(true);
                  }}
                >
                  Click here
                </Link>*/}
              </Grid>
            </Grid>
          </Grid>

          <Grid item className={classes.vertical0}>
            <SignupV2Button
              type="submit"
              variant="contained"
              disabled={submitting}
            >
              {" "}
              {submitting ? <CircularProgress size="2rem" /> : "SUBMIT"}
            </SignupV2Button>
          </Grid>
        </Grid>
      </form>
      <Dialog
        open={termsDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Terms and Conditions
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>Cookies – Acceptance policy</Typography>
          <Typography>
            <b>This website uses cookies</b>
          </Typography>
          <Typography
            style={{
              textAlign: "justify",
            }}
          >
            We use cookies to personalize content, to provide social media
            features and to analyses our traffic. We also share information
            about your use of our site with our social media, advertising and
            analytics partners who may combine it with other information that
            you’ve provided to them or that they’ve collected from your use of
            their services. Registered users of this site must agree to
            our Privacy Policy.
          </Typography>
          <br />
          <Typography>
            <b> 123Mentor Privacy Policy</b>
          </Typography>
          <Typography
            style={{
              textAlign: "justify",
            }}
          >
            The terms and conditions of this agreement is binding between Eva
            Consultancy Services(Hereinafter referred to as "Eva", "Company")
            which expression shall unless repugnant to the context or contrary
            to the meaning thereof shall mean and include its heirs, successors,
            administrators, executors, assigns, etc.) having its registered
            office at 2,Shree Apt, 56-Samarth Nagar, Nashik 422005 is the owner
            of the website 123 Mentor (Hereinafter referred to as the
            "website","123Mentor") and You , as an User of Website and Services
            i.e. 123mentor.in/com/com.au OR 123mentor.com or
            123mentor.com.au(Hereinafter referred to as the "User" "You" which
            expression shall unless repugnant to the context or contrary to the
            meaning thereof shall mean and include his/her/their heirs,
            successors, administrators, executors, assigns, etc.)
          </Typography>
          <br />
          <Typography>Effective Date: April 25, 2020</Typography>
          <br />
          <Typography>
            <ol>
              <li>
                {" "}
                about this document
                <ol>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    {" "}
                    123Mentor's Privacy Policy explains how we collect, use,
                    store and share the personal information you decide to share
                    and will help you make informed decisions when accessing or
                    using the 123Mentor website, located at www.123Mentor.com,
                    or any successor websites, including any and all
                    international and mobile versions thereof (collectively, the
                    "Website").
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    {" "}
                    By registering with 123Mentor, using or accessing the
                    Website, you are agreeing to the practices described in this
                    Privacy Policy. Your use of the Website is also subject to
                    the 123Mentor Code of Conduct and Terms of Use.
                    <b>
                      If you do not agree with these policies, do not access or
                      use our Services or interact with any other aspect of our
                      business.
                    </b>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    If you have questions or concerns regarding this statement,
                    you should contact our staff at &nbsp;
                    <Link>support@123Mentor.com.in.com.au</Link>
                  </li>
                </ol>
              </li>

              <li>
                123Mentor’s Privacy Principles
                <ol>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    {" "}
                    123Mentor operates as a social impact organization, although
                    for-profit. We are powered by volunteer mentors who care
                    deeply, a community based on mutual trust, and the belief
                    that a better world is possible
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    {" "}
                    We will never sell or rent your data to third parties.{" "}
                  </li>
                  <li>Your profile information is public. </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Other information that you provide to 123Mentor
                    is confidential.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Your conversations with others in the 123Mentor community
                    are confidential. It is also your responsibility to help us
                    keep it that way.
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    General information about your activity on the site helps us
                    to do our job.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    We only share data with trusted partners in order to:
                    improve our service, to measure our impact, and identify
                    misuse, and to respond to your requests.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    If you join 123Mentor through your employer or other
                    organization, some information about your activity will be
                    shared with them.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    You can control how we communicate with you.
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    You have rights to the information that we request or have
                    collected about you.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    You can ask to be removed from the community.{" "}
                  </li>
                  <li>
                    We are based in India, and data is transferred and held
                    securely within India-based data centres.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    When our global operations require us to transfer
                    information to other countries we utilize appropriate
                    safeguards.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    You can contact us at any time
                    at support@123Mentor.com.in.com.au{" "}
                  </li>
                </ol>
              </li>
              <li>
                About Us
                <ol>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    123Mentor is an initiative of Eva Consultancy Services a
                    for-profit, professional group of consultants ("123Mentor").
                    123Mentor's mission is to help businesses grow faster and
                    employ more people by making it easy to be a mentor, find a
                    mentor, and build a business.{" "}
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Our contact information is as follows:
                    support@123mentor.in/com/com.au
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    If you have joined 123Mentor through your employer or other
                    organization, you may be subject to their policies and
                    procedures regarding privacy and acceptable use of this
                    website. Please contact your program administrator for more
                    details.{" "}
                  </li>
                </ol>
              </li>
              <li
                style={{
                  textAlign: "justify",
                }}
              >
                Information we collect about you
                <ol>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Information you provide to us
                    <ol>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        Registration information
                        <ul>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            When you register with 123Mentor and create a user
                            profile to participate in 123Mentor's programs, you
                            provide us with certain personal and business
                            information, such as your name, your email address,
                            your telephone number, your postal code, your group
                            or company affiliations, and your password.
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            123Mentor also collects other contact, demographic
                            and business information in order to provide a
                            mentor matching service to facilitate virtual
                            mentoring, to provide other services provided by
                            123Mentor and as otherwise described in this Privacy
                            Policy.
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Information we receive from other sources
                    <ol>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        Other users
                        <ul>
                          <ul>
                            <li
                              style={{
                                textAlign: "justify",
                              }}
                            >
                              Messages, endorsements and feedback
                              <ul>
                                <li
                                  style={{
                                    textAlign: "justify",
                                  }}
                                >
                                  123Mentor may collect or request information
                                  about you from other users you have interacted
                                  with. This may include messages they exchanged
                                  with you, feedback on your conversations,
                                  ratings, or endorsements. We also collect
                                  negative feedback such as when there may be
                                  evidence of spam, solicitation, or fraud.
                                </li>
                              </ul>
                              <li
                                style={{
                                  textAlign: "justify",
                                }}
                              >
                                References
                                <ul>
                                  <li
                                    style={{
                                      textAlign: "justify",
                                    }}
                                  >
                                    123Mentor occasionally asks participants to
                                    submit references to us before being
                                    accepted into the program. 123Mentor stores
                                    this information for the sole purpose of
                                    conducting reference checks. The reference
                                    may contact 123Mentor at
                                    support@123Mentor.com.in.com.au to request
                                    the removal of this information from our
                                    database.
                                  </li>
                                </ul>
                              </li>
                            </li>
                          </ul>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Information we collect automatically when you use our
                    service
                    <ol>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        Device and web browsing data
                        <ul>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            When you access the Website, we collect your IP
                            address, browser type, internet service provider
                            (ISP), referring/exit pages, platform and device
                            type, date/time stamp, and number of clicks. This
                            information is gathered for all Website users.
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            We use your IP address and/or country preference in
                            order to approximate your location to provide you
                            with a better Service experience.{" "}
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            How much of this information we collect depends on
                            the type and settings of the device you use to
                            access the Services.{" "}
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li
                style={{
                  textAlign: "justify",
                }}
              >
                How we use information we collect
                <ol>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    To provide services and personalize your experience
                    <ul>
                      <li>
                        To match you with either a mentor or a mentee. Once a
                        match is made or you connect with another user, your
                        name and the URL of your public 123Mentor profile and
                        associated content will be supplied to the person you
                        have been matched with.
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    For research and development
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        To improve our services
                        <ul>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            To evaluate and improve the 123Mentor services and
                            the Website and offer personalized features.
                          </li>
                        </ul>
                      </li>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        For Impact measurement
                        <ul>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            We will also use non-identifiable, aggregate
                            information to guide our program efforts and report
                            to funders, stakeholders and external partners.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    To communicate with you about the service
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        To communicate with you regarding our services, the
                        mentoring process, and upcoming 123Mentor events or
                        initiatives.
                      </li>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        123Mentor may send you service-related announcements
                        from time to time through the general operation of the
                        service. For instance, if you receive a mentoring
                        request or an offer for mentoring advice, you may
                        receive an email or other message alerting you to that
                        fact.{" "}
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    To market and promote the service
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        With your explicit permission, we may use your personal
                        details to promote 123Mentor. You will be contacted
                        before any release of such information for 123Mentor's
                        promotional purposes, and you may withdraw any
                        permission that you may grant at any time.
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    For customer support{" "}
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        We communicate with users to provide requested services
                        and in regards to issues relating to their account. We
                        reply via email, regular mail or phone, depending on the
                        nature of the communication.{" "}
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    For safety and security{" "}
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        We use information about you and your Service use to
                        verify accounts and activity, to monitor suspicious or
                        fraudulent activity and to identify violations of
                        Service policies.
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    With your consent{" "}
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        We use information about you where you have given us
                        consent to do so for a specific purpose not listed
                        above. For example, we may publish testimonials or
                        featured customer stories to promote 123Mentor, or
                        display photographs of you from a 123Mentor event, with
                        your permission. In such instances, terms and conditions
                        for the collection and use of information will be stated
                        separately and made explicit to respondents in advance
                        of data collection.{" "}
                      </li>
                    </ul>
                  </li>
                  <li
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    Legal bases for processing (EEA users){" "}
                    <ul>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        If you are an individual in the European Economic Area
                        (EEA), we collect and process information about you only
                        where we have legal bases for doing so under applicable
                        EU laws. The legal bases depend on the Services you use
                        and how you use them. This means we collect and use your
                        information only where:{" "}
                        <ul>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            We need it to provide you the Services, including to
                            operate the Services, provide customer support and
                            personalized features and to protect the safety and
                            security of the Services;
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            It satisfies a legitimate interest (which is not
                            overridden by your data protection interests), such
                            as for research and development, to market and
                            promote the Services and to protect our legal rights
                            and interests.
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            You give us consent to do so for a specific purpose;
                            or
                          </li>
                          <li
                            style={{
                              textAlign: "justify",
                            }}
                          >
                            We need to process your data to comply with a legal
                            obligation.
                          </li>
                        </ul>
                      </li>
                      <li
                        style={{
                          textAlign: "justify",
                        }}
                      >
                        If you have consented to our use of information about
                        you for a specific purpose, you have the right to change
                        your mind at any time, but this will not affect any
                        processing that has already taken place. Where we are
                        using your information because we or a third party (e.g.
                        your employer) have a legitimate interest to do so, you
                        have the right to object to that use though, in some
                        cases, and this may mean no longer using the Services.6.
                        How we share information we collect
                      </li>
                    </ul>
                  </li>
                </ol>
              </li>
            </ol>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UserInfo = (props) => {
  useAuthenticated();

  const classes = useStyle();
  const redirect = useRedirect();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));

  const handleSubmit = async (values) => {
    //sanitize isMentor
    window.open(
      "https://signupforservices.com/whatsapp/optin/?bId=a4a6300a-3049-4f05-859a-bff1ff3a9dad&bName=123Mentor&s=URL&lang=en_US",
      "_blank"
    );

    console.log("value", values);
    values =
      typeof values.isMentor == "undefined"
        ? { isMentor: false, ...values }
        : values;

    console.log("values is mentor", values.isMentor);

    //sanitize profileImage
    if (typeof values.profileImage !== "undefined") {
      const ProfileBase64 = await toBase64(values.profileImage.rawFile);
      console.log("ProfileBase64", ProfileBase64);
      const profileImageFile = values.profileImage
        ? new Parse.File("Profileimage", {
            base64: ProfileBase64,
          })
        : null;
      console.log("profileImageFile", profileImageFile);
      delete values["profileImage"];
      values["profileImage"] = profileImageFile;
      values["profileImage"].save();
    }

    //Update user
    const user = Parse.User.current();
    // for (let key in values) {
    //   user.set(key, values[key]);
    // }
    user.set("username", values.email);
    user.set("email", values.email);
    user.set("email_", values.email);
    user.set("mobileNo", values.mobileNo);
    user.set("isMentor", values.isMentor);
    user.set("name", values.name);
    user.set("industry", values.industry);
    user.set("profileImage", values.profileImage);
    // Setting up default Availability object
    if (values.isMentor) {
      const Availability = Parse.Object.extend("Availability");
      let avail = new Availability();
      await avail.save().then(
        (a) => {
          console.log(`saved objectId: ${a.id}`);
          const ptr = Availability.createWithoutData(a.id);
          console.log(`object ptr: ${ptr}`);
          console.log(`values: ${JSON.stringify(values, 0, 2)}`);
          user.set("availability", ptr);
        },
        (e) => {
          console.log(`Availability Object : ${e}`);
        }
      );
    }

    // console.log(`user ready to save:${JSON.stringify(user, 0, 2)}`);

    await user.save().then(
      (resp) => {
        console.log(`on save user resp : ${JSON.stringify(resp, 0, 2)}`);
      },
      (error) => {
        console.log(error);
      }
    );

    localStorage.setItem("permissions", user.attributes.sessionToken);
    localStorage.setItem("user", user.id);
    console.log("User", user);
    const NewUser = await Parse.Cloud.run("NonCloudMail", {
      user: JSON.stringify(user),
      operation: "NewUser",
    });
    const NewUserWhatsApp = await Parse.Cloud.run("SendWhatsAppNotification", {
      user: JSON.stringify(user),
      operation: "NewUser",
    });

    console.log("NewUser", NewUser);
    console.log("NewUserWhatsApp", NewUserWhatsApp);

    redirect("/");
  };
  return (
    <ThemeProvider theme={mentorTheme}>
      {isDesktop ? (
        <Grid container alignItems="stretch">
          <Grid item md={6} className={classes.leftPanel}>
            <img
              alt="Become a Mentor"
              src={professionals}
              className={classes.bannerImage}
            />
          </Grid>
          <Grid item md={6} className={classes.rightPanel}>
            <Grid container direction="column">
              <Grid item className={classes.vertical20}>
                <Typography variant="h3" className={classes.bannerHeader}>
                  Become a 123Mentor!
                </Typography>
              </Grid>
              <Grid item>
                <Paper elevation={4} className={classes.formPaper}>
                  <Form onSubmit={handleSubmit} render={UserInfoFrom}></Form>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="stretch">
          <Grid item sm={12} className={classes.rightPanel}>
            <Grid container direction="column">
              <Grid item className={classes.vertical20}>
                <Typography variant="h4" className={classes.bannerHeader}>
                  Become a 123Mentor!
                </Typography>
              </Grid>
              <Grid item>
                <Paper elevation={4} className={classes.formPaperSm}>
                  <Form onSubmit={handleSubmit} render={UserInfoFrom}></Form>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </ThemeProvider>
  );
};
export default UserInfo;
